import { cx } from "../../lib/cx.js";
import { createContext, useContext } from "react";
//#region src/components/FormField/FormFieldContext.ts
var FormFieldContext = createContext(null);
/**
* For a control inside a FormField: its id (so the label points at it), its
* `aria-describedby` (the hint or error, plus any of its own) and whether it is invalid.
* The control's own props win. Outside a FormField it returns the props unchanged.
*/
function useFormFieldControl({ id, "aria-describedby": describedBy, invalid }) {
	const field = useContext(FormFieldContext);
	return {
		id: id ?? field?.id,
		"aria-describedby": cx(field?.describedBy, describedBy) || void 0,
		invalid: invalid ?? field?.invalid ?? false
	};
}
//#endregion
export { FormFieldContext, useFormFieldControl };

//# sourceMappingURL=FormFieldContext.js.map